<template>
  <div ref="canvasContainer" class="wordcloud-container">
    <canvas ref="wordCanvas"></canvas>
  </div>
</template>

<script>
import WordCloud from 'wordcloud';

export default {
  name: 'WordCloud',
  props: {
    words: {
      type: Array,
      required: true,
    }
  },
  mounted() {
    this.renderWordCloud();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    words() {
      this.renderWordCloud();
    }
  },
methods: {
  handleResize() {
    this.renderWordCloud();
  },
  renderWordCloud() {
    // Ensure the canvas is resized to fit the container
    const canvas = this.$refs.wordCanvas;
    const container = this.$refs.canvasContainer;
    canvas.width = container.clientWidth;
    canvas.height = container.clientHeight;

    let tooltip = container.querySelector('.wordcloud-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'wordcloud-tooltip';
      tooltip.style.position = 'absolute';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.background = 'rgba(0,0,0,0.8)';
      tooltip.style.color = '#fff';
      tooltip.style.padding = '4px 8px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '14px';
      tooltip.style.display = 'none';
      tooltip.style.zIndex = 10;
      container.appendChild(tooltip);
    }
    const counts = this.words.map(w => w[1]);
    const minCount = Math.min(...counts);
    const maxCount = Math.max(...counts);
    let gridSize = 30;
    if (container.clientWidth < 600) {
      gridSize = 8;
      }
    WordCloud(canvas, {
      shape: 'rectangle',
      ellipticity: 0.5,
      rotationSteps: 1,
      list: this.words,
      gridSize: gridSize,
    weightFactor: (size) => {
      const containerWidth = this.$refs.canvasContainer.clientWidth;
      const minFont = Math.max(15, containerWidth * 0.015);   
      const maxFont = Math.min(60, containerWidth * 0.06); 
      if (maxCount === minCount) return maxFont;
      return minFont + ((size - minCount) / (maxCount - minCount)) * (maxFont - minFont);
    },
      fontFamily: 'sans-serif',
      color: 'random-dark',
      backgroundColor: '#DDDDDD',
      drawOutOfBound: false,
      rotateRatio: 0.2,
      rotationSteps: 2,
      hover: (item, dimension, event) => {
        if (item) {
          tooltip.textContent = `${item[0]}: ${item[1]}`;
          tooltip.style.left = (event.offsetX + 10) + 'px';
          tooltip.style.top = (event.offsetY + 10) + 'px';
          tooltip.style.display = 'block';
        } else {
          tooltip.style.display = 'none';
        }
      },
      click: (item) => {
        if (item) {
          this.$emit('tag-click', item[0]);
        }
      }
    });
  }
}
};
</script>

<style scoped>
.wordcloud-container {
  width: 100%;
  height: 400px;
  padding: 1rem;
  box-sizing: border-box;
  margin: 0 auto; 
}
canvas {
  display: block;
  width: 100%;
  height: 100%;
}
.wordcloud-tooltip {
  transition: opacity 0.1s;
  pointer-events: none;
}

@media (max-width: 600px) {
  .wordcloud-container {
    height: 50vw;
    min-height: 120px;
    max-height: 220px;
  }
}
</style>